export const version = "experimental/5.6.0";
//# sourceMappingURL=_version.js.map